import { useEffect, useState } from "react";

import { OTPStep } from "@unified-checkout/design-system";

import { IOtpModal } from "@app/dashboard/types/innerLayout/transactions/modals/otp";

import styles from "./otpModalBody.module.scss";

const defaultText = {
  resendText: "Resend code in",
  resendBtnText: "resend",
};

export const OTPModalBody = ({
  length = 6,
  resendTimer = 150,
  onChangeHandler,
  onValidHandler,
  onResendOTP,
  localization = defaultText,
  error,
}: IOtpModal) => {

  const [otp, setOtp] = useState('');
  const [otpResetTimerKey, setOtpResetTimerKey] = useState(0);


  useEffect(() => {
    onChangeHandler?.(otp);
  }, [otp]);

  const handleResendOtp = () => {
    setOtpResetTimerKey((prev) => prev + 1);
    onResendOTP?.();
  };

  const validHandler = (valid: boolean) => {
    onValidHandler?.(valid);
  };

  return (
    <div className={styles["otp-wrapper"]}>
      <OTPStep
        otp={otp}
        setOtp={setOtp}
        onValid={validHandler}
        onResendOTP={handleResendOtp}
        resendText={localization?.resendText}
        resendBtnText={localization?.resendBtnText}
        resendTimer={resendTimer}
        length={length}
        error={error}
        otpResetTimerKey={otpResetTimerKey}
      />
    </div>
  )
};
